<template>
  <div class="table-management-container">
    <h1 class="title-centered title-black">{{ $t('gestion_tablas') }}</h1>
    <div class="tables-columns">
      <div class="tables-group">
        <h2 class="group-title group-title-black">{{ $t('tablas_usuarios') }}</h2>
        <button
          v-for="table in userTables"
          :key="table.key"
          class="btn-table"
          @click="openTable(table)"
        >
          {{ $t(table.label_plural) }}
        </button>
      </div>

      <div class="tables-group">
        <h2 class="group-title group-title-black">{{ $t('tablas_tickets') }}</h2>
        <button
          v-for="table in ticketTables"
          :key="table.key"
          class="btn-table"
          @click="openTable(table)"
        >
          {{ $t(table.label_plural) }}
        </button>
      </div>

      <!-- Columna de depuración: cada botón abre el modal de depuración -->
      <div class="tables-group">
        <h2 class="group-title group-title-black">{{ $t('tablas_depuracion') }}</h2>
      <!-- botón Depurar Tickets ya existe; añadimos botón Depurar Logs debajo -->
      <button class="btn-table btn-table-fixed" @click="openDebugModal(table)">Depurar Tickets</button>
  <button class="btn-table btn-table-fixed" style="margin-left:8px;" @click="showPurgeLogs = true">Depurar Logs</button>

      </div>
    </div>

    <!-- CrudModal sin overlay (render inline en la vista) -->
    <CrudModal
      v-if="showModal"
      :titulo="$t(selectedTable.label_plural)"
      :endpoint="selectedTable.endpoint"
      :esCategoria="selectedTable.key === 'categoria'"
      :esDelegacion="selectedTable.key === 'delegacion'"
      :campoNombre="selectedTable.campoNombre || 'nombre'"
      :showEsCierre="!!selectedTable.showEsCierre"
      @close="showModal = false"
      @refresh="fetchItems"
    />

    <!-- modal de depuración correcto -->
    <TableManagementDebugDatabaseModal
      v-if="showDebugModal"
      :visible="showDebugModal"
      @update:visible="showDebugModal = $event"
      :table="selectedDebugTable"
    />

    <PurgeUserLogsModal v-model:visible="showPurgeLogs" @done="onPurgeLogsDone" />
  </div>
</template>

<script>
import CrudModal from '@/components/CrudModal.vue';
import api from '@/api';
import TableManagementDebugDatabaseModal from '@/views/TableManagementDebugDatabaseModalView.vue';
import Swal from 'sweetalert2';
import PurgeUserLogsModal from '@/components/PurgeUserLogsModal.vue';
export default {
  components: {
    CrudModal,
    TableManagementDebugDatabaseModal,
    PurgeUserLogsModal
  },
  data() {
    return {
      userTables: [
        { key: 'delegacion', label: 'delegacion', label_plural: 'delegaciones', endpoint: '/delegaciones' },
        { key: 'departamento', label: 'departamento', label_plural: 'departamentos', endpoint: '/departamentos' },
      ],
      ticketTables: [
        { key: 'categoria', label: 'categoria', label_plural: 'categorias', endpoint: '/tickets/todascategorias', responseKey: 'categorias' },
        // Motivos de cierre: reusa el CrudModal indicando que el campo principal es 'descripcion' y que incluye el flag esCierre
        { key: 'motivo_cierre', label: 'motivo_cierre', label_plural: 'motivos_cierre', endpoint: '/tickets/motivos-cierre', responseKey: 'motivos', campoNombre: 'descripcion', showEsCierre: true }
      ],
      selectedTable: null,
      showModal: false,
      showDebugModal: false,
      selectedDebugTable: null,
      items: [],
      showPurgeLogs: false,
    };
  },
  methods: {
    async openTable(table) {
      this.selectedTable = table;
      await this.fetchItems();
      this.showModal = true;
    },
    openDebugModal(table) {
      this.selectedDebugTable = table;
      this.showDebugModal = true;
    },
    openPurgeLogsModal() {
      // Confirmación informativa; si confirma, reutiliza el modal de depuración para manejar logs
      Swal.fire({
        title: 'Depurar Logs (IRREVERSIBLE)',
        html: 'Esta operación eliminará logs de usuarios. ¿Deseas continuar y abrir la herramienta de depuración?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Abrir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#b12b34'
      }).then((result) => {
        if (result.isConfirmed) {
          this.selectedDebugTable = { key: 'logs', label_plural: 'Logs' }; // Asignar tabla de logs
          this.showDebugModal = true;
        }
      });
    },
    async fetchItems() {
      if (!this.selectedTable) return;
      const response = await api.get(this.selectedTable.endpoint);
      if (this.selectedTable.responseKey && response.data[this.selectedTable.responseKey]) {
        this.items = response.data[this.selectedTable.responseKey];
      } else {
        this.items = response.data;
      }
    },
    onPurgeLogsDone(info) {
      // opcional: refrescar vista o mostrar mensaje
      console.info('purge-user-logs done:', info);
    },
    // ...existing code...
  },
};
</script>

<style scoped>
.title-centered.title-black {
  text-align: center;
  margin-bottom: 32px;
  color: #222;
}

.group-title.group-title-black {
  font-size: 20px;
  font-weight: bold;
  color: #222;
  margin-bottom: 18px;
}

.tables-columns {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 32px;
}

.tables-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-table {
  background-color: #798a99;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 12px 24px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  margin-bottom: 18px;
  margin-right: 12px;
  min-width: 180px;
  box-sizing: border-box;
}

/* nuevo: igual longitud para botones de depuración */
.btn-table-fixed {
  width: 220px; /* ancho fijo igual para ambos botones de depuración */
  min-width: unset;
}

.btn-table:hover {
  background-color: #5e6e7a;
  color: #fff;
}
</style>

<!-- estilos GLOBALES para overlay/modal (no scoped) -->
<style>
/* overlay que ocupa TODO el viewport y centra el modal */
.modal-container {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 12px !important;
  background-color: rgba(0,0,0,0.55) !important;
  z-index: 10000 !important;
  overflow: auto !important;
}

/* contenedor que mantiene el CrudModal tal cual (no modifica su tamaño interno) */
.modal-wrapper {
  position: relative;
  z-index: 10001;
  width: 100%;
  max-width: 920px; /* límite visual, CrudModal sigue controlando su propio tamaño */
  box-sizing: border-box;
  margin: 0 auto;
}

.table-management-debug-modal {
  position: relative;
  z-index: 10001;
  width: auto;
  max-width: 920px;
}
</style>